//@ts-nocheck
import React, { useEffect, useState } from "react";
import actionElements from "../../../config/actionElements.json";
import styles from "./ActionElement.module.scss";
import Requirement from "./Requirement/Requirement";
import InfoBubble from "../InfoBubble/InfoBubble";

function ActionElement(props) {
	const { actionElement, color, index, value, handleSubmit, templateData } = props;

	const [childElementsValues, setChildElementsValues] = useState(handleSetupExistingValueFromStringActionElements());
	const [requirementValues, setRequirementValues] = useState(handleSetupExistingValueFromStringRequirements());

	// Re-sync state if the value prop changes after initial mount (e.g. parent finishes loading)
	useEffect(() => {
		setChildElementsValues(handleSetupExistingValueFromStringActionElements());
		setRequirementValues(handleSetupExistingValueFromStringRequirements());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	function handleSetupExistingValueFromStringActionElements() {
		let newValue = value;
		if (!value && value !== "") {
			newValue = "";
		}
		// need to parse out the existing first
		// first turn into an array based on the actionElement's delimiter
		// determine if its an action element or a requirement and the index
		// set the values
		const childElementsValuesCopy = [];

		if (actionElement.delimiter?.includes("EMBED")) {
			// this is one that is setup with the requirements embedded i.e. "${EMBED}"
			// So this will have to organize each requirement by what is embedded in each part (the EMBED)
			// rather than directly using a delimiter to split it out.
		} else if (!actionElement.delimiter) {
			// No delimiter — splitting target by "" would produce individual characters.
			// Instead, use regex to find {A0}, {A1}, etc. in the target and map each to
			// the corresponding position in the value array (which is just [value] here).
			const actionElementValueArray = getActionValueArray();
			const regex = /\{A(\d+)\}/g;
			let pos = 0;
			let match;
			while ((match = regex.exec(actionElement.target)) !== null) {
				const idx = parseInt(match[1]);
				childElementsValuesCopy[idx] = actionElementValueArray[pos++];
			}
		} else {
			let actionElementValueArray = getActionValueArray();

			let actionElementTargetArray = actionElement.target.split(actionElement.delimiter);
			if (actionElement.requirements.includes("MADLIB")) {
				// Madlib delimiter is a little different and these actually dont need to be handled!!
				// There should always be a special action element for each madlib, we will eventually need
				// mixed type madlibs but this is fine for now.
				actionElementTargetArray = [actionElement.target];
				actionElementValueArray = [newValue];
			}
			// MADLIBS NEED SPECIAL TREATMENT HERE
			for (let i = 0; i < actionElementTargetArray.length; i++) {
				const element = actionElementTargetArray[i];
				const valueElement = actionElementValueArray[i];

				if (element.includes("A")) {
					// need to parse the number out not just set to i.
					const index = element.replace(/[{A}]/g, "");
					childElementsValuesCopy[index] = valueElement;
				}
			}
		}
		return childElementsValuesCopy;
	}

	/**
	 * Takes the value of the exportData and returns it as an array
	 * @author Eric Webb <ewebb@factorearth.com>
	 * @returns An array of strings, whether it just be an array with the {newValue} in it or that value split on a delimiter
	 */
	function getActionValueArray() {
		if (actionElement.delimiter) {
			if (actionElement.delimiter === "CHARCODE_31") {
				return value.split(String.fromCharCode(31));
			} else {
				return value.split(actionElement.delimiter);
			}
		} else {
			return [value];
		}
	}

	function handleSetupExistingValueFromStringRequirements() {
		let newValue = value;
		if (!value && value !== "") {
			newValue = "";
		}
		// need to parse out the existing first
		// first turn into an array based on the actionElement's delimiter
		// determine if its an action element or a requirement and the index
		// set the values
		const requirementValuesCopy = [];
		if (actionElement.delimiter?.includes("EMBED")) {
			// For EMBED delimiter with MADLIB, the whole value is the madlib string — no splitting needed.
			if (actionElement.requirements?.includes("MADLIB")) {
				requirementValuesCopy[0] = newValue ?? "";
			}
		} else {
			let actionElementValueArray = getActionValueArray();
			let actionElementTargetArray = actionElement.target.split(
				actionElement.delimiter === "CHARCODE_31" ? String.fromCharCode(31) : actionElement.delimiter,
			);
			if (actionElement.requirements.includes("MADLIB")) {
				// Madlib delimiter is a little different and these actually dont need to be handled!!
				// There should always be a special action element for each madlib, we will eventually need
				// mixed type madlibs but this is fine for now.
				actionElementTargetArray = [actionElement.target];
				actionElementValueArray = [newValue];
			}
			// MADLIBS NEED SPECIAL TREATMENT HERE
			for (let i = 0; i < actionElementTargetArray.length; i++) {
				const element = actionElementTargetArray[i];
				const valueElement = actionElementValueArray[i];
				const index = element.replace(/[{R}]/g, "");
				requirementValuesCopy[index] = valueElement;
			}
		}
		return requirementValuesCopy;
	}

	function handleChangeChildElement(element, index) {
		const childElementsCopy = [...childElementsValues];
		childElementsCopy[index] = element;
		setChildElementsValues(childElementsCopy);
		handleSubmitActionElement({ editedChildElements: childElementsCopy });
	}

	/**
	 * Savs the requirement data in state at this level to do things with.
	 * @param {string} requirement that was entered by the user
	 * @param {int} index of the requirement
	 */
	function handleSubmitRequirement(requirement, index) {
		const requirementCopy = [...requirementValues];
		requirementCopy[index] = requirement;
		setRequirementValues(requirementCopy);
		handleSubmitActionElement({ editedRequirement: requirementCopy });
	}

	function renderActionElement() {
		const elements = [];
		const requirements = [];
		for (let i = 0; i < actionElement.elements.length; i++) {
			const element = actionElement.elements[i];
			const elementHtml = (
				<ActionElement
					elementIndex={i}
					handleSubmit={handleChangeChildElement}
					color={color}
					value={childElementsValues[i]}
					index={i}
					templateData={templateData}
					actionElement={element}
				/>
			);

			elements.push(elementHtml);
		}

		// This is kinda weird for the moment, but its like this to prevent unknown issues on export action end when they need options
		// (ORIGINALLY SET UP TO USE THESE HARDCODED OPTIONS FOR DEV PURPOSES) - IT IS HERE TO PREVENT ACCIDENTAL OTHER ISSUES FOR NOW.
		const options =
			actionElement.requirements === "OPTION_IDS" || actionElement.requirements === "OPTION_DOCID"
				? templateData.options.items
				: [
						{
							header: "FIRST ONE",
							id: "1",
						},
						{
							header: "SECOND ONE",
							id: "2",
						},
					];

		for (let i = 0; i < actionElement.num; i++) {
			const requirementHtml = (
				<Requirement
					index={i}
					actionElement={actionElement}
					optionData={options}
					templateData={templateData}
					color={color}
					value={requirementValues[i]}
					handleSubmit={handleSubmitRequirement}
				/>
			);
			requirements.push(requirementHtml);
		}

		const finalHtml = (
			<div>
				<div>{elements}</div>
				<div>{requirements}</div>
			</div>
		);

		return finalHtml;
	}

	/**
	 * replaces the configurations in the action element to match the input from the user, then triggers the submit
	 * @param editedRequirement The updated requirement value. (optional, you only need this is if you want to submit immediately)
	 * @param editedChildElements the updated child elements value. optional
	 */
	function handleSubmitActionElement({
		editedRequirement,
		editedChildElements,
	}: {
		editedRequirement: string[] | undefined;
		editedChildElements: string[] | undefined;
	}) {
		let target = actionElement.target;
		// should enforce the requirements here (validation n whatnot)
		const requirementsToUse = editedRequirement || requirementValues;
		const childElementsToUse = editedChildElements || childElementsValues;
		if (requirementsToUse.length > 0) {
			// the requirements!!!
			for (let i = 0; i < requirementsToUse.length; i++) {
				const requirement = requirementsToUse[i];
				// This is only using the .replace because there will only be one of each thing at each
				// level. (FOR NOW, if this is needed to replace all then reqex should be used instead).
				const subStr = `{R${i}}`;
				target = target.replace(subStr, requirement);
			}
		}

		if (childElementsToUse.length > 0) {
			// the elements!!!
			for (let i = 0; i < childElementsToUse.length; i++) {
				const childElement = childElementsToUse[i] ?? "";
				// This is only using the .replace because there will only be one of each thing at each
				// level. (FOR NOW, if this is needed to replace all then reqex should be used instead).
				const subStr = `{A${i}}`;
				target = target.replace(subStr, childElement);
			}
		}

		handleSubmit(target, index);
	}

	return (
		<div className={styles.inputWrapper} style={{ borderBottom: `1px dotted ${color.border.secondary}` }}>
			<label style={{ color: color.text.secondary }} className={styles.header} htmlFor="edit_export_data">
				{/* <div className={styles.header_text}>Custom Data:</div> */}
				<InfoBubble description={actionElement.requirementInstructions} />
			</label>
			{actionElement && actionElement !== "" ? renderActionElement() : null}
			{/* <Button colorPalette={color} onClick={handleSubmitActionElement}>Submit Action Element</Button> */}
		</div>
	);
}

export default ActionElement;
